export default __webpack_public_path__ + "files/dacfa646ab3389dc39bbd1c49a2d104d.png";